import axios from 'axios';

/**
 * 获取采集记录
 */
export const getCollections = (params) => {
  return axios.get('/api/collections', { params });
};
export const getSycollections = (params) => {
  return axios.get('/api/sycollections', { params });
};
export const getZdcollections = (params) => {
  return axios.get('/api/zdcollections', { params });
};

/**
 * 获取阵列位移计节点采集详情
 */
export const getDetails = (collectionId) => {
  return axios.get(`/api/collections/${collectionId}/details`);
};

/**
 * 获取初始采集记录
 */
export const getInitCollection = (params) => {
  return axios.get('/api/collections/init', { params });
};

/**
 * 获取最新采集记录
 */
export const getLatestCollection = (params) => {
  return axios.get('/api/collections/latest', { params });
};
export const getLatestSycollection = (params) => {
  return axios.get('/api/sycollections/latest', { params });
};
export const getLatestZdcollection = (params) => {
  return axios.get('/api/zdcollections/latest', { params });
};

/**
 * 获取报表数据（最新报表或有截止时间的报表）
 */
export const getLatestReport = (params) => {
  const { deviceId, reportDate } = params;
  if (reportDate) {
    return axios.get(`/api/latestReport/${deviceId}?reportDate=${reportDate}`);
  }
  return axios.get(`/api/latestReport/${deviceId}`);
};

/**
 * 获取分量图采集数据
 */
export const getChartCollections = (params) => {
  return axios.get('/api/collections/chart', { params });
};
export const getSYChartCollections = (params) => {
  return axios.get('/api/sycollections/chart', { params });
};
export const getZDChartCollections = (params) => {
  return axios.get('/api/zdcollections/chart', { params });
};

/**
 * 获取方位图采集数据
 */
export const getCoordinateCollections = (params) => {
  return axios.get('/api/collections/coordinate', { params });
};

/**
 * 获取隧道收敛图采集数据
 */
export const getTunnelCollections = (params) => {
  return axios.get('/api/collections/tunnel', { params });
};

/**
 * 获取数据实验室采集数据
 */
export const getLabCollections = (params) => {
  return axios.get('/api/collections/lab', { params });
};

/**
 * 获取组合数据
 */
export const getUnionSYCollections = (params) => {
  return axios.get('/api/sycollections/union', { params });
};

/**
 * 删除采集记录
 */
export const deleteCollection = (params) => {
  return axios.delete(`/api/collections/${params.id}`);
};
export const deleteSycollection = (params) => {
  return axios.delete(`/api/sycollections/${params.id}`);
};
export const deleteZdcollection = (params) => {
  return axios.delete(`/api/zdcollections/${params.id}`);
};

// 按照时间段删除数据
export const bulkDeleteCollection = (params) => {
  const { deviceId, startTime, endTime } = params;
  return axios.post('/api/collections/bulk-delete', {
    deviceId, startTime, endTime,
  });
};

// 按照多个时间点删除数据
export const bulkDeleteCollectionByIds = (params) => {
  const { deviceId, ids } = params;
  return axios.post('/api/collections/bulk-delete', {
    deviceId, ids,
  });
};

// 补充数据
export const manualCreate = (params) => {
  return axios.post('/api/collections/manual-insert', params);
};

